import { RecurrenceInterval, RECURRENCE_INTERVAL_DISPLAY } from "@mimber/schema"

/**
 * Shared recurrence interval dropdown options, derived from
 * @mimber/schema's display config so labels stay in sync with the enum.
 * Used by any form billing on a recurring interval (membership tiers,
 * group dues, etc).
 */
export const RECURRENCE_INTERVAL_OPTIONS = (
  Object.entries(RECURRENCE_INTERVAL_DISPLAY) as [
    RecurrenceInterval,
    { label: string },
  ][]
).map(([value, { label }]) => ({ label, value }))
